module.exports = __webpack_public_path__ + "img/lh.3d797944.png";